module.exports = __webpack_public_path__ + "static/media/coupon02_zhChs.a205aa3d.png";